import { ItemType } from './types.js';
// Food restoration values (percentage of hunger restored)
export const FOOD_RESTORATION = {
    [ItemType.BERRIES]: 0.15, // +15% hunger
    [ItemType.RAW_MEAT]: 0.25, // +25% hunger (mood penalty later)
    [ItemType.COOKED_MEAT]: 0.4, // +40% hunger
    [ItemType.BREAD]: 0.35, // +35% hunger
    // Fish - Raw
    [ItemType.RAW_MINNOW]: 0.1,
    [ItemType.RAW_SHRIMP]: 0.18,
    [ItemType.RAW_TROUT]: 0.15,
    [ItemType.RAW_COD]: 0.15,
    [ItemType.RAW_SALMON]: 0.2,
    [ItemType.RAW_SWAMP_EEL]: 0.2,
    // Fish - Cooked
    [ItemType.COOKED_MINNOW]: 0.2,
    [ItemType.COOKED_SHRIMP]: 0.36,
    [ItemType.COOKED_TROUT]: 0.3,
    [ItemType.COOKED_COD]: 0.35,
    [ItemType.COOKED_SALMON]: 0.4,
    [ItemType.COOKED_EEL]: 0.45,
    // Fish - Advanced
    [ItemType.FISH_STEW]: 0.6,
};
export const isFood = (itemType) => {
    return itemType in FOOD_RESTORATION;
};
export const getFoodRestoration = (itemType) => {
    return FOOD_RESTORATION[itemType] ?? 0;
};
//# sourceMappingURL=food.js.map